export default __webpack_public_path__ + "static/media/shenzhen-city-night-unsplash.3c8077fe.jpg";